import React, {useContext} from 'react';
import {useParams} from "react-router-dom";
import OrganizationHistoryTemplate from "../../../components/Templates/OrganizationHistoryTemplate";
import CheckboxCell from "../../../components/Pages/TablePage/Table/Cells/CheckboxCell";
import TextCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/TextCell/TextCell";
import {AuthContext} from "../../../context/AuthContext";

function OrgHistory() {
    let {medId, orgName, orgId, history} = useParams()
    const {REACT_APP_URL_PREFIX} = process.env
    const userId = useContext(AuthContext)?.token?.userId

    const accessResultCell = (props) => {
        return <CheckboxCell payed={props.cellContent}
                             updateUrl={`/api/v2/verificationCenters/${userId}/medCenters/${medId}/organizations/${orgId}/histories/${props.idArr[0]}/payed`}/>
    }

    tableModel.haveToShow[6].typeData.cell = accessResultCell
    return (
        <OrganizationHistoryTemplate
            addNewStudyConfig={{
                API: `/api/v2/verificationCenters/${userId}/medCenters/${medId}/organizations/${orgId}/histories?`,
                show: true
            }}
            getOrgHistoryAPI={`/api/v2/verificationCenters/${userId}/medCenters/${medId}/organizations/${orgId}/histories?`}
            tableModel={tableModel}
            breadCrumbsItems={[
                {title: 'Контрагенты'},
                {title: orgName, link: REACT_APP_URL_PREFIX + `/counterAgents/MedCenterOrgList/${medId}/${orgName}`},
                { title: history, link: REACT_APP_URL_PREFIX + `/counterAgents/MedCenterOrgList/${medId}/${orgName}/organizations/${orgId}/${history}`, actual: true }
                ]}
        />
    );
}

export default OrgHistory;

var tableModel =
    {
        haveToShow: [
            {id: 'organization_info', idArr: ['id'], type: 'linkToOrgPatients', typeData: {show: 'name'}},
            {id: 'document', type: 'uploadLists', idArr: ['id'], typeData: {uploaded: 'uploaded'}},
            {id: 'date', type: 'wrapperCell', typeData: {
                    cell: props => <TextCell
                        text={props.cellContent}/>
                }
            },
            {id: 'patients_count'},
            {id: 'base'},
            {id: 'invite_count'},
            {id: 'payed', idArr: ['id'], typeData: {cell: () => {}}, type: 'wrapperCell'},
            {id: 'id', type: 'emailSend'},
        ],
        firstRow:
            [
                {title: 'Название', id: 'name', sortFunction: function () {}},
                {title: 'Загрузить списки', id: '', sortFunction: function () {}},
                {title: 'Год', id: 'resultDate', sortFunction: function () {}},
                {title: 'Исследований', id: '', sortFunction: function () {}},  // Сортировка не добавлена
                {title: 'Вид исследования', id: 'base', sortFunction: function () {}},
                {title: 'Вызов', id: '', sortFunction: function () {}},  // Сортировка не добавлена
                {title: 'Доступ к результату', id: '', sortFunction: function () {}},
                {title: 'Печать', id: '', sortFunction: function () {}}
            ],
    }
